import React from 'react'
import Footer from '../components/footerComponent/footer'
import AddGroup from '../components/teacherComponent/addGroupComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function AddGroupPage() {
    return (
        <Layout>
            <Header/>
            <AddGroup/>
            <Footer/>
        </Layout>
    );
};